// extracted by mini-css-extract-plugin
export var experience = "bx_bD";
export var slide = "bx_bC";
export var swiper = "bx_bB";